import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import TopHeader from './TopHeader';
import Sidebar from './Sidebar';

export default function AppLayout() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <>
      <TopHeader />
      <div className="container-fluid m-0">
        <div className="row">
          <Sidebar darkMode={darkMode} setDarkMode={setDarkMode} />
          <div id="sidebarOverlay" onClick={() => {
            document.getElementById('sidebar').classList.remove('active');
            document.getElementById('sidebarOverlay').classList.remove('active');
          }}></div>
          <div className="aside p-0" id="mainAside">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
